import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {getSupportedNewsletterTypes} from 'src/openapi/admin/apis/NewsletterDictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectNewsLetterTypes} from './services/dictionary-slice';

let isRequestPending = false;

export const useNewsletterDictionary = ({skip}: {skip?: boolean} = {}) => {
    const apiDispatch = useAppDispatch();
    const newsletterDictionary = useSelector(selectNewsLetterTypes);

    useEffect(() => {
        if (skip) {
            return;
        }
        if (newsletterDictionary.length) {
            isRequestPending = false;
            return;
        }
        if (!isRequestPending) {
            isRequestPending = true;
            apiDispatch(getSupportedNewsletterTypes({featureForce: false}));
        }
    }, [newsletterDictionary.length, apiDispatch, skip]);

    const newsletterLabels = useMemo(() =>
        Object.fromEntries(newsletterDictionary.flatMap(item =>
            item.children?.map(c => [c.id, c.description]) ?? [[item.id, item.description]],
        )),
    [newsletterDictionary]);

    return {newsletterDictionary, newsletterLabels};
};
